/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChangeRoleRequest,
  GetApiV1UsersParams,
  ProblemDetails,
  SetSuspensionRequest,
  UserSummaryDtoPagedList,
  ValidationProblemDetails
} from '.././model';

import { request } from '../../http-client';




export const getApiV1Users = (
    params?: GetApiV1UsersParams,
 signal?: AbortSignal
) => {
      
      
      return request<UserSummaryDtoPagedList>(
      {url: `/api/v1/users`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1UsersQueryKey = (params?: GetApiV1UsersParams,) => {
    return [
    `/api/v1/users`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1UsersQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Users>>, TError = ProblemDetails>(params?: GetApiV1UsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Users>>> = ({ signal }) => getApiV1Users(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Users>>>
export type GetApiV1UsersQueryError = ProblemDetails


export function useGetApiV1Users<TData = Awaited<ReturnType<typeof getApiV1Users>>, TError = ProblemDetails>(
 params: undefined |  GetApiV1UsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Users>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Users>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Users<TData = Awaited<ReturnType<typeof getApiV1Users>>, TError = ProblemDetails>(
 params?: GetApiV1UsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Users>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Users>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Users<TData = Awaited<ReturnType<typeof getApiV1Users>>, TError = ProblemDetails>(
 params?: GetApiV1UsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Users<TData = Awaited<ReturnType<typeof getApiV1Users>>, TError = ProblemDetails>(
 params?: GetApiV1UsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiV1UsersUserIdRoles = (
    userId: string,
    changeRoleRequest: ChangeRoleRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/users/${userId}/roles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changeRoleRequest, signal
    },
      );
    }
  


export const getPostApiV1UsersUserIdRolesMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdRoles>>, TError,{userId: string;data: ChangeRoleRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdRoles>>, TError,{userId: string;data: ChangeRoleRequest}, TContext> => {

const mutationKey = ['postApiV1UsersUserIdRoles'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UsersUserIdRoles>>, {userId: string;data: ChangeRoleRequest}> = (props) => {
          const {userId,data} = props ?? {};

          return  postApiV1UsersUserIdRoles(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UsersUserIdRolesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UsersUserIdRoles>>>
    export type PostApiV1UsersUserIdRolesMutationBody = ChangeRoleRequest
    export type PostApiV1UsersUserIdRolesMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1UsersUserIdRoles = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdRoles>>, TError,{userId: string;data: ChangeRoleRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UsersUserIdRoles>>,
        TError,
        {userId: string;data: ChangeRoleRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1UsersUserIdRolesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putApiV1UsersUserIdSuspension = (
    userId: string,
    setSuspensionRequest: SetSuspensionRequest,
 ) => {
      
      
      return request<void>(
      {url: `/api/v1/users/${userId}/suspension`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setSuspensionRequest
    },
      );
    }
  


export const getPutApiV1UsersUserIdSuspensionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdSuspension>>, TError,{userId: string;data: SetSuspensionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdSuspension>>, TError,{userId: string;data: SetSuspensionRequest}, TContext> => {

const mutationKey = ['putApiV1UsersUserIdSuspension'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1UsersUserIdSuspension>>, {userId: string;data: SetSuspensionRequest}> = (props) => {
          const {userId,data} = props ?? {};

          return  putApiV1UsersUserIdSuspension(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1UsersUserIdSuspensionMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1UsersUserIdSuspension>>>
    export type PutApiV1UsersUserIdSuspensionMutationBody = SetSuspensionRequest
    export type PutApiV1UsersUserIdSuspensionMutationError = ProblemDetails

    export const usePutApiV1UsersUserIdSuspension = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdSuspension>>, TError,{userId: string;data: SetSuspensionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1UsersUserIdSuspension>>,
        TError,
        {userId: string;data: SetSuspensionRequest},
        TContext
      > => {

      const mutationOptions = getPutApiV1UsersUserIdSuspensionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteApiV1UsersUserIdRolesRole = (
    userId: string,
    role: string,
 ) => {
      
      
      return request<void>(
      {url: `/api/v1/users/${userId}/roles/${role}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteApiV1UsersUserIdRolesRoleMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdRolesRole>>, TError,{userId: string;role: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdRolesRole>>, TError,{userId: string;role: string}, TContext> => {

const mutationKey = ['deleteApiV1UsersUserIdRolesRole'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1UsersUserIdRolesRole>>, {userId: string;role: string}> = (props) => {
          const {userId,role} = props ?? {};

          return  deleteApiV1UsersUserIdRolesRole(userId,role,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1UsersUserIdRolesRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1UsersUserIdRolesRole>>>
    
    export type DeleteApiV1UsersUserIdRolesRoleMutationError = ProblemDetails

    export const useDeleteApiV1UsersUserIdRolesRole = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdRolesRole>>, TError,{userId: string;role: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1UsersUserIdRolesRole>>,
        TError,
        {userId: string;role: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiV1UsersUserIdRolesRoleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    